const acceptLegalConsignee = (
    consigneeId,
    successAction = (response) => {
        location.reload();
    },
    failAction = (jqXHR) => {
        // @ts-ignore
        defaultFailActionRu(jqXHR);
    }
) => {
    $.post({cache: false, url: `/consignee/accept-legal-entity?id=${consigneeId}`, data: {}})
        .done(function (response) {
            successAction(response);
        })
        .fail(function (jqXHR) {
            failAction(jqXHR);
        });
};

const snapToObject = (
    recipientId,
    successAction = (response) => {
        location.reload();
    },
    failAction = (jqXHR) => {
        window.alert(
            "Ошибка при выполнении действия\n" +
            "Статус: " + jqXHR['statusText'] + "\n" +
            "Код статуса: " + jqXHR['status'] + "\n" +
            "Ответ сервера: " + jqXHR['responseText']
        );
    }
) => {
    $.post({cache: false, url: `/consignee/snap-to-object?id=${recipientId}`, data: {}})
        .done(function (response) {
            successAction(response);
        })
        .fail(function (jqXHR) {
            failAction(jqXHR);
        });
};

$(document).on('click', '#reject-recipient', function (e) {
    e.preventDefault();
    const rejectReasonId = $(`#reject-reason-id`).val();

    if (rejectReasonId) {
        const form = $('#form-reject-recipient')[0];
        // @ts-ignore
        const formData = new FormData(form);
        const recipientId = $(`#recipient_id`).val();
        $('#reject-recipient').attr("disabled", "disabled");

        $.ajax({
            url: `/consignee/reject?id=${recipientId}`,
            method: 'POST',
            data: formData,
            contentType: false,
            processData: false
        })
            .done(function (data) {
                alert(data.message)
                location.reload();
            })
            .fail(function (r) {
                alert(r.responseJSON.message);
                location.reload();
            });
    } else {
        alert("Причина отклонения данных обязательна");
    }
});
